import { useEffect, useState } from "react";
import { GroupedCardView } from "../../../components/StudentComponents";
import { useApp } from "../../../hooks/AppProvider";

import "../../../css/behavior.css";
import { ANIMATION_CONTROL } from "../../../components/BasicComponents";

const ANIMATIONS = {
    redCard: {
        keyframes: [
            {
                transform: "translateX(0)"
            },
            {
                transform: "translateX(5px)"
            },
            {
                backgroundColor: "var(--danger-dark-color)",
                transform: "translateX(-5px)"
            },
            {
                transform: "translateX(5px)"
            },
            {
                transform: "translateX(0)"
            }
        ],
        options: {
            fill: "forwards",
            easing: "linear",
            duration: 300
        }
    },
    greenCard: {
        keyframes: [
            {
                transform: "scale(1)"
            },
            {
                backgroundColor: "var(--valid-dark-color)",
                 transform: "scale(1.05)"
            },
            {
                 transform: "scale(1)"
            }
        ],
        options: {
            fill: "forwards",
            easing: "ease-in-out",
            duration: 400
        }
    },
};

function BehaviorCard({ st_card: student, onClickNegative, onClickPositive }) {

    const onClickNegative0 = () => {
        onClickNegative(student.id, -1);
    };

    const onClickPositive0 = () => {
        onClickPositive(student.id, 1);
    };

    return (
        <div className="behavior-card-button-container">
            <button onClick={onClickPositive0} className="behavior-card-button positive-behavior">+1</button>
            <button onClick={onClickNegative0} className="behavior-card-button negative-behavior">-1</button>
        </div>
    );
}

function BehaviorPoints() {

    const app = useApp();
    const [students, setStudents] = useState([]);
    const [groups, setGroups] = useState([]);
    const [assignments, setAssignments] = useState([]);

    const [sessionStarted, setSessionStarted] = useState(false);

    const [animation, setAnimation] = useState({});

    useEffect(() => {
        app.sendGet("/student/listmy", data => {
            setStudents(data.sort((a, b) => a.name.localeCompare(b.name)));
        });

        app.sendGet("/behavior/list", data => {
            setGroups(data.sort((a, b) => a.name.localeCompare(b.name)));
        });

        app.sendGet("/behavior/assignments", data => {
            setAssignments(data);
        });

        app.sendGet("/behavior/session/current", data => {
            if(data.success !== false)
                setSessionStarted(true);
        });

    }, []);

    const updatePoints = (studentId, amount) => {
        app.sendPost("/behavior/points/add", {student_id: studentId, amount: amount}, data => {
            
            if(amount < 0) {
                const newAnimation = ANIMATIONS.redCard;
                newAnimation.id = studentId;
                setAnimation(newAnimation);
            }else if(amount > 0) {
                
                const newAnimation = ANIMATIONS.greenCard;
                newAnimation.id = studentId;
                setAnimation(newAnimation);
            }
        });
    }

    const onClickPositiveBehavior = (studentId, amount) => {
        updatePoints(studentId, amount)
    };

    const onClickNegativeBehavior = (studentId, amount) => {
        updatePoints(studentId, amount)
    };

    const onAnimationEnd = (e) => {
        setAnimation(undefined);
    };

    const onStartSession = () => {
        app.sendGet("/behavior/session/start", data => {
            if(data.success === false)
                return alert("Une session est déjà en cours");

            setSessionStarted(true);
        });
    };

    const onStopSession = () => {
        if(!window.confirm("Vous êtes sur le point de terminer la session. Souhaitez-vous continuer ?")) {
            return;
        }
        app.sendGet("/behavior/session/stop", data => {
            if(data.success === false)
                return alert("Aucune session en cours");

            setSessionStarted(false);
        });
    }

    const onAnimationClick = () => {
        app.navigate("/behavior-session-animation");
    }

    return (
        <div>
            <h1>Points</h1>
            {students.length > 0 ? (
                <>
                    <div className="behavior-button-container">
                        {sessionStarted ? (
                            <button className="button-delete" onClick={onStopSession}>Terminer la session</button>
                        ) : (
                            <button onClick={onStartSession}>Démarrer la session</button>
                        )}
                        { groups.length > 0 && assignments.length > 0 && (
                            <button onClick={onAnimationClick}>Récapitulatif de la dernière session</button>
                        )}
                    </div>
                    
                    <GroupedCardView
                        students={students}
                        groups={groups}
                        assignments={assignments}
                        remainingGroupName={"Sans groupe"}
                        onClickPositive={onClickPositiveBehavior}
                        onClickNegative={onClickNegativeBehavior}
                        element={BehaviorCard}

                        anim_keyframes={animation?.keyframes ?? []}
                        anim_options={animation?.options ?? {}}
                        anim_id={animation?.id ?? -1}
                        anim_defaultControl={ANIMATION_CONTROL.PLAY}
                        onAnimationEnd={onAnimationEnd}
                    />
                </>
            ) : (
                <h2 className="error-text">Vous n'avez pas d'élève</h2>
            )}
            
        </div>
    );

}

export default BehaviorPoints;